module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 63
// module chunks = 0